import Main from './PaymentMethodsMain'
import Steps from './PaymentMethodsSteps'
import IntegrationToken from './PaymentMethodsIntegrationToken'
import SelectMethods from './PaymentMethodsSelectMethods'
import Configuration from './PaymentMethodsConfiguration'
import Edit from './PaymentMethodsEdit'

export default {
  Main,
  Steps,
  IntegrationToken,
  SelectMethods,
  Configuration,
  Edit,
}
